import type { SpacerTypes } from 'types'

export const Spacer = ({
  size,
  vertrical = false,
  horizontal = false,
  style = {},
  ...props
}: SpacerTypes) => {
  // flex grow spacer
  if (!size) return <span style={{flexGrow: 1}}></span>

  // box spacer
  const width = vertrical ? 1 : size
  const height = horizontal ? 1 : size
  const display = horizontal ? 'inline-block' : 'block'
  const styles = {
    display,
    width,
    minWidth: width,
    height,
    minHeight: height,
    ...style,
  }
  return <span style={styles} {...props} />
}